import RpcService              from '@/core/services/Rpc/RpcService';
import RpcResponse             from '@/core/services/Rpc/RpcResponse';

import type TransportRoute     from '@/domains/TransportRoutes/TransportRoute';
import type RpcDataPagination  from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort        from '@/core/services/Rpc/RpcDataSort';

/**
 * DAO для работы с маршрутами доставки
 */
class TransportRoutesDAO {

	/**
	 * Загружает маршрут по ID
	 */
	static async get(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportRoutes.get', { id });
	}

	/**
	 * Загружает маршрут по паре зон (отправления и назначения)
	 */
	static async getByZones(fromId: number, toId: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportRoutes.get', { fromId, toId });
	}

	/**
	 * Загружает список маршрутов
	 */
	static async getList(
		filters?: Record<string, unknown>,
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'transportRoutes.getList',
			filters,
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	/**
	 * Создаёт маршрут
	 */
	static async add(transportRoute: TransportRoute): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportRoutes.add', { transportRoute });
	}

	/**
	 * Обновляет маршрут
	 */
	static async update(transportRoute: TransportRoute): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportRoutes.update', { transportRoute });
	}

	/**
	 * Удаляет маршрут (soft delete)
	 */
	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportRoutes.delete', { id });
	}
}

export default TransportRoutesDAO;
